import { Stack, Box, Paper, Container } from '@mui/material';
import PropTypes from 'prop-types';

const NoData = ({ src, helperText, sx, padding, ...others }) => {
  return (
    <Container>
      <Paper elevation={0} sx={{ py: padding }}>
        <Stack mx="auto" p={4} alignSelf="center" alignItems="center" spacing={2}>
          <Box sx={{ ...sx }} maxWidth="300px" component="img" width="100%" src={src} {...others} />
          {helperText}
        </Stack>
      </Paper>
    </Container>
  );
};

NoData.propTypes = {
  src: PropTypes.string.isRequired,
  helperText: PropTypes.node,
  sx: PropTypes.object,
  padding: PropTypes.number,
  others: PropTypes.object,
};

export default NoData;
